const AbstractCloverTransaction = require('@/lib/PaymentMethods/Clover/AbstractCloverTransaction');
const CloverTransactionClassName = require('@/lib/PaymentMethods/Clover/Enums/CloverTransactionClassName');
const CloverTransactionEndState = require('@/lib/PaymentMethods/Clover/Enums/CloverTransactionEndState');
const RefundData = require('@/lib/PaymentMethods/Clover/RefundData');
const { toMinorUnit } = require('@/functions/math');

// This is a slimmed down version of CloverTransaction that is used to handle refunding an existing transaction.
// See also: CloverVoidTransaction
class CloverRefundTransaction extends AbstractCloverTransaction {
    constructor(refundData) {
        super(CloverTransactionClassName.REFUND);
        if (!(refundData instanceof RefundData)) {
            throw new Error('CloverRefundTransaction requires an instance of refundData');
        }

        /**
         * The Clover paymentId
         *
         * @type {string}
         */
        this.paymentId = refundData.payment.transactionRef.replaceAll('"', '');

        /**
         * The DigiTickets paymentID of the payment we are refunding.
         *
         * @type {number}
         */
        this.originalPaymentID = refundData.payment.ID;

        /**
         * @type {string|null}
         */
        this.thirdPartyID = null;

        /**
         * The total amount to refund in minor units.
         *
         * @type {number}
         */
        this.amountInMinorUnits = toMinorUnit(refundData.refundAmount);

        this.originalAmountInMajorUnits = refundData.refundAmount;

        /**
         * @type {boolean}
         */
        this.fullRefund = refundData.refundAmount === refundData.payment.amount * -1;

        /**
         * @type {RefundData}
         */
        this.initialRefundData = refundData;
    }

    addResponse(response) {
        this.latestResponse = response;

        if (!this.latestResponse) {
            throw new Error('Missing response');
        }

        // Update the userMessage if there is a new userMessage otherwise leave any existing userMessage.
        if (this.latestResponse.data && this.latestResponse.data.message) {
            this.userMessage = this.latestResponse.data.message;
        }

        // Check the response if it isn't 200 then update messages but don't continue.
        if (!this.isHttpResponseSuccess()) {
            return;
        }

        // The final state of the transaction.
        if (this.latestResponse.data) {
            if (this.latestResponse.data.refund) {
                this.transactionResult.message = CloverTransactionEndState.REFUNDED;
            }
        }
    }
}

module.exports = CloverRefundTransaction;
